import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';

import * as tenantProfileActions from 'actions/tenantProfileActions';
import { explosionCelebration } from 'actions/notificationActions';
import { getTenantTodoList } from 'actions/todoActions';

import { toFriendlyDateString, formatMoney } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';

import { PaymentStatus } from 'components/shared/StatusHelper';
import RentBreakdown from 'components/shared/RentBreakdown';
import StripePayment from 'components/shared/StripePayment';
import HistoricPayments from './shared/HistoricPayments';

import Autorenew from '@material-ui/icons/AccountBalance';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import { getTranslatedString } from 'helpers/i18n';
import { getTenancyStatus } from 'actions/dashboardActions';

let TenantPayDialog = class TenantPayDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      paymentDialogOpen: false,
      paymentType: 'general',
    };
  }

  deleteByVal(val, obj) {
    for (const key in obj) {
      if (obj[key] === val) delete obj[key];
    }
  }

  togglePaymentDialog = () => {
    this.setState({ paymentDialogOpen: !this.state.paymentDialogOpen });
  };

  handleToken = token => {
    return this.props.makeRentPayment(this.props.paymentDetails.id, token, this.props.paymentDetails.payment_type).then(() => {
      this.props.explosionCelebration();
      this.props.getTenantTodoList();
      this.props.getTenancyStatus();
      this.props.payments();
      this.props.toggleDialog();
      this.togglePaymentDialog();
    });
  };

  render() {
    if (hostIsBoardwalk()) return null;
    const data = this.props.paymentDetails || { historic_payments: [] };
    const paymentDetails = data.payment_details || [];
    const tenantOverview = this.props.tenantOverview || {};

    this.deleteByVal('$0.00', paymentDetails);

    const style = {
      table_header: {
        margin: '5px -20px 10px -20px',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
        borderRadius: '8px',
      },
      due_date: {
        color: '#6F6F6F',
        fontSize: '15px',
        textAlign: 'center',
      },
      payment_details: {
        fontSize: '12px',
      },
    };

    return (
      <div>
        <StripePayment
          open={this.state.paymentDialogOpen}
          toggleOpen={this.togglePaymentDialog}
          pricing={data.pricing_object}
          onToken={this.handleToken}
          fullScreen={this.props.fullScreen}
        />
        <Dialog
          open={this.props.isOpen}
          onClose={this.props.toggleDialog}
          aria-labelledby="payment-details-dialog"
          classes={{ paper: 'form-dialog' }}
          fullScreen={this.props.fullScreen}
        >
          <DialogTitle id="payment-details-dialog">
            <h3 style={{ margin: '10px 0 5px', textAlign: 'center' }}>
              {getTranslatedString('paymentDetails')}
              <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>.</b>&nbsp;
              <span>{<PaymentStatus style={{ fontSize: '52%' }} status={data.status} />}</span>
            </h3>
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                borderTop: `5px solid ${AccentColor()}`,
                marginTop: '5px',
                paddingTop: '20px',
              }}
            >
              <div
                className="row"
                style={{ fontSize: '15px', margin: '15px auto 0', maxWidth: '350px' }}
              >
                <RentBreakdown paymentDetails={paymentDetails} />
              </div>

              <div className="row" style={{ margin: 'auto', width: '350px' }}>
                <hr style={{ margin: '10px 0', borderTop: '2px solid' }} />
              </div>

              <div
                className="row"
                style={{ fontSize: '15px', margin: '0px auto 10px', maxWidth: '350px' }}
              >
                <div className="row" style={{ fontSize: '15px', marginTop: '10px' }}>
                  <div className="col-xs-6" style={{ padding: '0px 5px', fontWeight: '800' }}>
                    <h4 style={{ margin: 0 }}> {getTranslatedString('total')} </h4>
                  </div>
                  <div className="col-xs-6" style={{ padding: '0px 5px', textAlign: 'right' }}>
                    <p id="no-margin"> {formatMoney(data.amount_in_float)} </p>
                  </div>
                </div>
                <div className="row" style={{ fontSize: '15px', marginTop: '10px' }}>
                  <div className="col-xs-6" style={{ padding: '0px 5px', fontWeight: '800' }}>
                    <h4 style={{ margin: 0 }}> {getTranslatedString('totalOutstanding')} </h4>
                  </div>
                  <div className="col-xs-6" style={{ padding: '0px 5px', textAlign: 'right' }}>
                    <p id="no-margin"> {formatMoney(data.amount_outstanding_in_float)} </p>
                  </div>
                </div>
              </div>

              <h5 style={{ textAlign: 'center', margin: '18px 0 25px' }}>
                {getTranslatedString('paymentDueOn')}{' '}
                <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>
                  {toFriendlyDateString(data.due_date)}
                </b>
              </h5>

              {tenantOverview.use_payment_platform && (
                <Fragment>
                  <div className="row" style={style.table_header}>
                    <h4 style={{ margin: '0', textAlign: 'center' }}>
                      {' '}
                      {getTranslatedString('paymentOptions')}{' '}
                    </h4>
                  </div>
                  <div className="row" style={{ display: 'flex' }}>
                    <div
                      className={`col-xs-${data.status === 'Autopay' ? '12' : '6'}`}
                      id="hover-select"
                      style={{ marginTop: '15px' }}
                      onClick={this.togglePaymentDialog}
                    >
                      <div
                        style={{
                          width: '85px',
                          height: '85px',
                          margin: 'auto',
                          textAlign: 'center',
                          borderRadius: '100px',
                          border: `4px solid ${AccentColor()}`,
                          cursor: 'pointer',
                          paddingTop: '11px',
                        }}
                      >
                        <CreditCardIcon
                          style={{ color: AccentColor(), height: '55px', width: '55px' }}
                        />
                      </div>
                      <p
                        style={{
                          textAlign: 'center',
                          fontFamily: 'Circular-Bold',
                          marginTop: '10px',
                        }}
                      >
                        {getTranslatedString('payment.CreditCard')}
                      </p>
                    </div>
                    {data.status !== 'Autopay' && (
                      <div
                        className="col-xs-6"
                        id="hover-select"
                        style={{ marginTop: '15px' }}
                        onClick={this.props.toggleAutopay}
                      >
                        <div
                          style={{
                            width: '85px',
                            height: '85px',
                            margin: 'auto',
                            textAlign: 'center',
                            borderRadius: '100px',
                            border: `4px solid ${AccentColor()}`,
                            cursor: 'pointer',
                            paddingTop: '9px',
                            paddingLeft: '3px',
                          }}
                        >
                          <Autorenew
                            style={{ color: AccentColor(), height: '55px', width: '55px' }}
                          />
                        </div>
                        <p
                          style={{
                            textAlign: 'center',
                            fontFamily: 'Circular-Bold',
                            marginTop: '10px',
                          }}
                        >
                          {getTranslatedString('payment.autopay')}
                        </p>
                      </div>
                    )}
                  </div>
                  {data.status === 'Autopay' && (
                    <div className="row" style={{ marginTop: '20px' }}>
                      <p style={{ textAlign: 'justify' }}>
                        {' '}
                        <i className="em em-raised_hands" />
                        <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>
                          {' '}
                          {getTranslatedString('headsUp')}!{' '}
                        </b>
                        <i className="em em-raised_hands" />
                        &nbsp;
                        {getTranslatedString('autopay.autopayActiveWarning')}
                      </p>
                    </div>
                  )}
                  {data.status !== 'Autopay' && (
                    <div className="row" style={{ marginTop: '20px' }}>
                      <p style={{ textAlign: 'justify' }}>
                        {' '}
                        <i className="em em-raised_hands" />
                        <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>
                          {' '}
                          {getTranslatedString('headsUp')}!{' '}
                        </b>
                        <i className="em em-raised_hands" />
                        &nbsp;
                        {getTranslatedString('autopay.about')}
                      </p>
                    </div>
                  )}
                </Fragment>
              )}
            </div>

            <HistoricPayments data={data} />
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.props.toggleDialog}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              {getTranslatedString('close')}
            </FlatButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
};

export default withMobileDialog()(
  connect(
    store => {
      return {
        tenantOverview: store.dashboard.tenantOverview,
      };
    },
    { ...tenantProfileActions, getTenantTodoList, explosionCelebration, getTenancyStatus }
  )(TenantPayDialog)
);
